<template>
  <div v-if="totalPage > 0" :class="$style.pager">
    <!-- 1つ前に戻るボタン -->
    <button v-if="currentPage > 1" type="button" :class="$style.arrow" @click.prevent="updatePage(currentPage - 1)">
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
        <path
          d="M10.0057 11L14.2043 15.1986L13.005 16.398L7.60693 11L13.005 5.60194L14.2043 6.80216L10.0057 11.0008V11Z"
          fill="#567EB4"
        />
      </svg>
    </button>
    <!-- 先頭のページ -->
    <button v-if="currentPage > 2" type="button" @click.prevent="updatePage(1)">1</button>
    <!-- 三点リーダー -->
    <template v-if="currentPage > 3">
      <svg xmlns="http://www.w3.org/2000/svg" width="17" height="3" viewBox="0 0 17 3" fill="none">
        <circle cx="1.5" cy="1.5" r="1.5" fill="#D4DBE5" />
        <circle cx="8.5" cy="1.5" r="1.5" fill="#D4DBE5" />
        <circle cx="15.5" cy="1.5" r="1.5" fill="#D4DBE5" />
      </svg>
    </template>
    <!-- 前のページ -->
    <button v-if="currentPage > 1" type="button" @click.prevent="updatePage(currentPage - 1)">
      {{ currentPage - 1 }}
    </button>
    <!-- 現在のページ -->
    <button type="button" :class="$style.currentNum">{{ currentPage }}</button>
    <!-- 次のページ -->
    <button v-if="currentPage < totalPage" type="button" @click.prevent="updatePage(currentPage + 1)">
      {{ currentPage + 1 }}
    </button>
    <!-- 三点リーダー -->
    <template v-if="currentPage < totalPage - 2">
      <svg xmlns="http://www.w3.org/2000/svg" width="17" height="3" viewBox="0 0 17 3" fill="none">
        <circle cx="1.5" cy="1.5" r="1.5" fill="#D4DBE5" />
        <circle cx="8.5" cy="1.5" r="1.5" fill="#D4DBE5" />
        <circle cx="15.5" cy="1.5" r="1.5" fill="#D4DBE5" />
      </svg>
    </template>
    <!-- 最後のページ -->
    <button v-if="currentPage < totalPage - 1" type="button" @click.prevent="updatePage(totalPage)">
      {{ totalPage }}
    </button>
    <!-- 1つ次に進むボタン -->
    <button
      v-if="currentPage !== totalPage"
      type="button"
      :class="$style.arrow"
      @click.prevent="updatePage(currentPage + 1)"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
        <path
          d="M11.9938 11L7.79517 6.8013L8.99454 5.60193L14.3926 11L8.99454 16.398L7.79517 15.1978L11.9938 10.9991L11.9938 11Z"
          fill="#567EB4"
        />
      </svg>
    </button>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from "vue"
import { useRoute, useRouter } from "vue-router"
import VueScrollTo from "vue-scrollto"

const props = withDefaults(
  defineProps<{
    /** 合計ページ数 */
    totalPage: number
    /** ページ更新時にスクロールが必要であればスクロール先IDを指定（#不要） */
    scrollId?: string
    /** ページ更新時の処理をemitでoverrideする場合は`emit`を指定 */
    updatePageMode?: "updateQuery" | "emit"
  }>(),
  {
    updatePageMode: "updateQuery",
    scrollId: "",
  },
)

const emit = defineEmits<{
  (e: "updatePage", value: number): void
}>()

const route = useRoute()
const router = useRouter()
const currentPage = ref(1)

const updatePage = (_num: number): void => {
  if (props.updatePageMode === "emit") {
    emit("updatePage", _num)
    currentPage.value = _num
    return
  }

  const query = route.query
  if (query.page) {
    delete query.page
  }
  router.push({ query: { page: _num, ...query } })
  if (props.scrollId) {
    VueScrollTo.scrollTo(`#${props.scrollId}`, 500)
  }
}

watch(
  () => route.fullPath,
  () => {
    currentPage.value = route.query.page ? Number(route.query.page) : 1
  },
  { immediate: true },
)
</script>

<style scoped module lang="scss">
.pager {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.625rem;
  font-size: $font-size-16;
  button {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    border: 1px solid $primary-40;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.2s ease-in-out;
    background-color: $white;
    &:hover {
      background-color: $primary-10;
    }
    &.currentNum {
      font-size: $font-size-14;
      background-color: $primary;
      color: $white;
      pointer-events: none;
    }
    &.arrow {
      background-color: $primary-20;
      border-color: $primary-20;
      &:hover {
        background-color: $primary-40;
      }
    }
  }
}
</style>
